import { render, staticRenderFns } from "./ScheduleOrders.vue?vue&type=template&id=bad37376"
import script from "./ScheduleOrders.vue?vue&type=script&lang=js"
export * from "./ScheduleOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports